import type { Incident, IncidentCategory } from '../realtime/contracts';
import { IncidentState } from '../realtime/contracts';
import { getAgencyView } from './incidentDomain';
import { orderIncidentsByCreatedTimeDescending } from './incidentListQueries';

function selectByCategory(
  incidents: readonly Incident[] | undefined,
  agencyId: string,
  category: IncidentCategory,
): Incident[] {
  if (incidents == null) {
    return [];
  }

  return orderIncidentsByCreatedTimeDescending(
    incidents.filter((incident) => (getAgencyView(incident, agencyId)?.category ?? 'Open') === category),
  );
}

export function selectForwardedIncidents(incidents: readonly Incident[] | undefined, agencyId: string): Incident[] {
  return selectByCategory(incidents, agencyId, 'Forwarded');
}

export function selectCurrentlyOpenIncidents(incidents: readonly Incident[] | undefined, agencyId: string): Incident[] {
  return selectByCategory(incidents, agencyId, 'Open');
}

export function selectRecentClosedIncidents(incidents: readonly Incident[] | undefined, agencyId: string): Incident[] {
  return selectByCategory(incidents, agencyId, 'Closed');
}

export function selectIncidentMapPoints(incidents: readonly Incident[] | undefined): Incident[] | undefined {
  return incidents?.filter((incident) => incident.state === IncidentState.Open);
}
